/**
 * @generated SignedSource<<b013f08ec28f56fd06d5bb9ce539ed21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateGitlabVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createGitlabVerificationKeyMutation$variables = {
  input: CreateGitlabVerificationKeyInput;
};
export type createGitlabVerificationKeyMutation$data = {
  readonly createGitlabVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createGitlabVerificationKeyMutation = {
  variables: createGitlabVerificationKeyMutation$variables;
  response: createGitlabVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGitlabVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createGitlabVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createGitlabVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createGitlabVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d08a1412b9388a943bcd043f4ba5e665",
    "id": null,
    "metadata": {},
    "name": "createGitlabVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createGitlabVerificationKeyMutation(\n  $input: CreateGitlabVerificationKeyInput!\n) {\n  createGitlabVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "d846396c2ae25166f3f78f9801c7344f";

export default node;
